import { useQuery, QueryFunction } from 'react-query';
import { getAttendedUsersByResponseId, FormResponseUsersWithDetailsResponse } from '../../../../services/apiSLTP/qhse/forms/formResponseUsers';

type UseAttendedUsersQueryOptions = { responseId: string };

const fetchAttendedUsers: QueryFunction<FormResponseUsersWithDetailsResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseAttendedUsersQueryOptions];
    return await getAttendedUsersByResponseId(options.responseId);
};

export const useFormAttendedUsersQuery = (options: UseAttendedUsersQueryOptions) => {
    return useQuery(['formAttendedUsers', options], fetchAttendedUsers);
};
